import {
  CHANGE_INPUT,
  CHANGE_INPUT_ERROR,
  CHANGE_STEP,
  FORGOT_PASSWORD_INITIATE,
  FORGOT_PASSWORD_INITIATE_FAILURE,
  FORGOT_PASSWORD_INITIATE_SUCCESS,
  FORGOT_PASSWORD_VERIFY,
  FORGOT_PASSWORD_VERIFY_FAILURE,
  FORGOT_PASSWORD_VERIFY_SUCCESS,
  RESET_INPUT_ERRORS,
  RESET_STATE,
} from './constants';

export function changeInput({ field, form, value }) {
  return {
    payload: { field, form, value },
    type: CHANGE_INPUT,
  };
}

export function changeInputError({ field, form, value }) {
  return {
    payload: { field, form, value },
    type: CHANGE_INPUT_ERROR,
  };
}

export function changeStep(step, view) {
  return {
    payload: { step, view },
    type: CHANGE_STEP,
  };
}

export function forgotPasswordInitiate({ username }) {
  return {
    payload: { username },
    type: FORGOT_PASSWORD_INITIATE,
  };
}

export function forgotPasswordInitiateFailure({ bannerError, error, validationErrors }) {
  return {
    payload: { bannerError, error, validationErrors },
    type: FORGOT_PASSWORD_INITIATE_FAILURE,
  };
}

export function forgotPasswordInitiateSuccess() {
  return { type: FORGOT_PASSWORD_INITIATE_SUCCESS };
}

export function forgotPasswordVerify({ linkQueryString, newPassword }) {
  return {
    payload: { linkQueryString, newPassword },
    type: FORGOT_PASSWORD_VERIFY,
  };
}

export function forgotPasswordVerifyFailure({ bannerError, error, validationErrors }) {
  return {
    payload: { bannerError, error, validationErrors },
    type: FORGOT_PASSWORD_VERIFY_FAILURE,
  };
}

export function forgotPasswordVerifySuccess() {
  return { type: FORGOT_PASSWORD_VERIFY_SUCCESS };
}

export function resetInputErrors({ field, form }) {
  return {
    payload: { field, form },
    type: RESET_INPUT_ERRORS,
  };
}

export function resetState() {
  return { type: RESET_STATE };
}
